import * as styles from "./styles";

interface ErrorMessageProps {
  children: React.ReactElement | string | null;
  isVisible: boolean;
}

export const ErrorMessage = ({ children, isVisible }: ErrorMessageProps) =>
  isVisible ? <styles.Container>{children}</styles.Container> : null;

ErrorMessage.defaultProps = {
  isVisible: false,
};
